import { render, staticRenderFns } from "./ItemEmpreendimento.vue?vue&type=template&id=282f56bc&scoped=true&lang=pug"
import script from "./ItemEmpreendimento.vue?vue&type=script&lang=js"
export * from "./ItemEmpreendimento.vue?vue&type=script&lang=js"
import style0 from "./ItemEmpreendimento.styl?vue&type=style&index=0&id=282f56bc&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f56bc",
  null
  
)

export default component.exports